import { createFileRoute } from "@tanstack/react-router";
import { ReconciliationDashboard } from "@/features/reconciliation";

export const Route = createFileRoute(
  "/_authenticated/_organization/reconciliation/"
)({
  component: ReconciliationPage,
});

function ReconciliationPage() {
  return (
    <div className="container mx-auto py-6">
      <ReconciliationDashboard />
    </div>
  );
}
